
import {LocalStorageParameterName} from "../../Constants";

export const useParameter = () => {

    const GetParameterLoaded = () => JSON.parse(localStorage.getItem(LocalStorageParameterName));

    return {
      GetParameterLoaded
    }
}